exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".note-item[data-v-6c0c2187]:last-child{border-bottom:none!important;margin-bottom:0!important;padding-bottom:0!important}.note-content[data-v-6c0c2187]{word-break:break-word}.mention[data-v-6c0c2187]{font-size:.85em}", ""]);

// exports
